import React, { useEffect } from "react";
import { API_BASE_URL } from "../config";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "./PaymentSuccess.css"; // Make sure to create this CSS file

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get("session_id");
  const profileId = searchParams.get("profile_id");
  const packageId = searchParams.get("package_id");
  const paymentDone = searchParams.get("eaypaisapayment");

  useEffect(() => {
    const handleSuccess = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/stripe/payment-success`,
          {
            params: {
              session_id: sessionId,
              profile_id: profileId,
              package_id: packageId,
            },
          }
        );
        console.log(response.data);

        // If payment success, call user/package API
        if (response.data.statusCode === 1) {
          const user = JSON.parse(sessionStorage.getItem("user"));
          const user_id = user?.payLoad?.user?.Id;
          if (user_id) {
            const response = await axios.get(
              `${API_BASE_URL}/user/package`,
              {
                params: {
                  user_id: user_id,
                },
              }
            );
            const data = response.data;
            if (data.statusCode === 1) {
              // Update session immediately so navbar updates
              const user = JSON.parse(sessionStorage.getItem("user"));
              user.payLoad.user.userPackages = data.payLoad;
              sessionStorage.setItem("user", JSON.stringify(user));
              // Optionally, trigger a custom event to notify other components
              window.dispatchEvent(new Event("userPackageUpdated"));
              const getSession = JSON.parse(sessionStorage.getItem("user"));
              console.log("Session of success payment", getSession);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching payment success:", error);
      }
    };

    if (sessionId) {
      handleSuccess();
    }
  }, [sessionId, profileId, packageId]);

  useEffect(() => {
    const handleEasySuccess = async () => {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const user_id = user?.payLoad?.user?.Id;
      try {
        const responseRaw = await fetch(
          `${API_BASE_URL}/activate/package`,
          {
            method: "POST",
            body: JSON.stringify({
              user_id: user_id,
              package_id: packageId,
            }),
          }
        );
        const response = { data: await responseRaw.json() };
        // If payment success, call user/package API
        if (response.data.statusCode === 1) {
          if (user_id) {
            const response = await axios.get(
              `${API_BASE_URL}/user/package`,
              {
                params: {
                  user_id: user_id,
                },
              }
            );
            const data = response.data;
            if (data.statusCode === 1) {
              // Update session immediately so navbar updates
              const user = JSON.parse(sessionStorage.getItem("user"));
              user.payLoad.user.userPackages = data.payLoad;
              sessionStorage.setItem("user", JSON.stringify(user));
              // Optionally, trigger a custom event to notify other components
              window.dispatchEvent(new Event("userPackageUpdated"));
              const getSession = JSON.parse(sessionStorage.getItem("user"));
              console.log("Session of success payment", getSession);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching payment success:", error);
      }
    };

    if (paymentDone) {
      handleEasySuccess();
    }
  }, [paymentDone, packageId]);

  return (
    <>
      <Navbar />
      <div className="payment-success-container">
        <img
          src="/payment-successful.png"
          alt="Payment Success"
          className="success-image"
        />
        <h2 style={{ color: "#00bcd4" }}>Payment Successful!</h2>
        <p>
          Thank you for your purchase. Your transaction has been completed and
          your package has been activated.
        </p>
        <button className="home-button" onClick={() => navigate("/")}>
          Go Back
        </button>
      </div>
      <Footer />
    </>
  );
};

export default PaymentSuccess;
